<template>
  <div>
    <footer class="text999 f13">
      <div class="flex align-center justify-around w1200 footer_top">
        <!-- 二维码 -->
        <div class="textwhite textc mt10">
          <div>{{$t("footer.wapTips")}}</div>
          <img src="../assets/images/gzh.jpg"
               alt=""
               width="83"
               height="83" />
          <div style="margin-bottom:5px;">{{$t("footer.wapLink")}}</div>
        </div>
          <!-- 意见反馈 -->
        <div class="feedBack" @click="goToFeedBack">
          <img src="../assets/images/feedBack.png"  >
          <span class="feed">{{ $t("footer.feedBack") }}</span>
        </div>
        <!-- 远程链接 -->
        <!-- <div>
          <div class="flex align-center textwhite  borderb pt5 pb5" style="font-weight:700;font-size:14px">
            {{ $t("footer.link2Des") }}
          </div>
           <div class="pt5 pb5">
              <a href="https://www.ars.arkray.co.jp/Login.aspx"
               target="_blank"
               class="textwhite" style="font-weight:700;font-size:14px">{{ $t("footer.link2") }}</a>
            </div>
        </div> -->
        <!-- 友情链接 -->
        <div>
          <div class="flex align-center textwhite borderb pt5 pb5">
            <a href="http://arkray.cn/"
               target="_blank"
               class="textwhite">{{ $t("footer.link1") }}</a>
            <span class="pl15 pr15 textwhite">|</span>
            <a target="_blank"
               class="textwhite"
               @click="toBannerDetail">{{ $t("footer.new") }}</a>
          </div>
          <div class="pt5 pb5">
            <a href="#/advertising"
               class="pointer clauses textwhite">{{ $t("footer.privacyPolicy") }}</a>
            <span class="pl15 pr15 textwhite">|</span>
            <a
               target="_blank"
               @click="toUserClauses"
               class="pointer clauses textwhite">{{ $t("footer.UseClauses") }}</a>
            <!-- <span class="pl15 pr15 textwhite">|</span>
            <a target="_blank"
               class="pointer clauses textwhite"
               @click="toBannerDetail">{{ $t("footer.new") }}</a> -->
          </div>
        </div>
        <!-- 地址电话 -->
        <div class="textwhite addr"
             style="max-width:365px">
          <div>{{ $t("footer.comName") }}</div>
          <div>{{ $t("footer.phone") }}400-8203867/021-5081-2554</div>
          <div>{{ $t("footer.addr") }}</div>
        </div>
      </div>
      <div class="footer_bottom flex align-center justify-center">
        <span class="pr20">©️copyright2020-2021</span>
        <img src="../assets/images/beian.png"
             alt=""
             width="16"
             height="16" />
        <a target="_blank"
           href="https://beian.miit.gov.cn"
           rel="nofollow"
           class="text999 pl10">沪ICP备19013058号-2</a>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currRouterPath:'',
    }
  },
  props:[
      'routerPath'
  ],
  watch: {
      routerPath: function(newVal){
      this.currRouterPath=newVal //newVal即是currRouterPath
      },
  },
  methods: {
    goToFeedBack(){
      if ( this.currRouterPath=="/login") {

      }else{
          this.$router.push({path:'/my/feedBack'})
      }

    },
    toUserClauses(){
      if ( this.currRouterPath=="/login") {

      }else{
          this.$router.push({path:'/useClauses'})
      }
    },
    toBannerDetail () {
      //   if ( this.currRouterPath=="/login") {

      // }else{
              var sendData = {};
      var that = this;
      this.$http.post("notice/queryTopBannber", sendData).then(function (res) {
        if (200 == res.data.code) {
          that.$router.push({
            path: "/bannerDetails",
            query: {
              title: res.data.data.title,
              noticeCode: res.data.data.noticeCode,
              examCode: res.data.data.examCode,
            },
          })
        }
      });
      // }
    }
  }
};
</script>
<style lang="less" >
footer {
  background-color: #828182;
  min-height: 180px;
}
footer > div {
  line-height: 35px;
}
.footer_top {
  min-height: 150px;
}
footer a:hover {
  text-decoration: underline;
}
.footer_bottom {
  height: 40px;
  line-height: 40px;
  background-color: #fff;
}
.addr div {
  line-height: 26px;
}
.feedBack{
color:#fff;
font-size:18px;
 img{
 width:25px;
 height:25px;
 position: relative;
 top: 3px;
 margin-right: 3px;
}
}
.feed:hover{
  cursor: pointer;
  border-bottom: 1px solid #fff;
}
</style>
